if (!customElements.get("quick-add-drawer")) {
  class t extends SideDrawer {
    constructor() {
      super(), this.content = this.querySelector(".js-product-details"), this.footer = this
        .querySelector(".drawer__footer"), this.form = this.querySelector("product-form"), this
        .notification = this.querySelector(".js-added-to-cart"), this.backBtn = this
        .querySelector(".drawer__back-btn"), this.openCartDrawerLinks = this.querySelectorAll(
          ".js-open-cart-drawer"), this.cartDrawer = document.querySelector("cart-drawer"), this
        .fetch = null, this.fetchedUrls = [], this.quickAddButtonMouseEnterHandler = this
        .handleQuickAddButtonMouseEnter.bind(this), this.documentClickHandler = this
        .handleDocumentClick.bind(this), document.addEventListener("click", this
          .documentClickHandler), this.addEventListener("on:variant:change", this
          .handleVariantChange.bind(this)), this.openCartDrawerLinks.forEach(t => {
          t.addEventListener("click", this.handleOpenCartClick.bind(this))
        }), theme.device.hasHover && theme.mediaMatches.md && (document.querySelectorAll(
          ".js-quick-add").forEach(t => {
          this.bindQuickAddButtonMouseEnter(t)
        }), "MutationObserver" in window && (this.observer = new MutationObserver(t => {
          t.forEach(t => {
            t.addedNodes.forEach(t => {
              t.nodeType === Node.ELEMENT_NODE && t.querySelectorAll(
                ".js-quick-add").forEach(t => {
                this.bindQuickAddButtonMouseEnter(t)
              })
            }), t.removedNodes.forEach(t => {
              t.nodeType === Node.ELEMENT_NODE && t.querySelectorAll(
                ".js-quick-add").forEach(t => {
                t.removeEventListener("mouseenter", this
                  .quickAddButtonMouseEnterHandler)
              })
            })
          })
        }), this.observer.observe(document.body, {
          childList: !0,
          subtree: !0
        })))
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.documentClickHandler), document.querySelectorAll(
        ".js-quick-add").forEach(t => {
        t.removeEventListener("mouseenter", this.quickAddButtonMouseEnterHandler)
      }), this.observer && this.observer.disconnect()
    }
    bindQuickAddButtonMouseEnter(t) {
      t.dataset.quickAddListenerAdded || (t.dataset.quickAddListenerAdded = "true", t
        .addEventListener("mouseenter", this.quickAddButtonMouseEnterHandler))
    }
    handleQuickAddButtonMouseEnter(t) {
      this.fetchedUrls.includes(t.target.dataset.productUrl) || (this.fetch = {
        url: t.target.dataset.productUrl,
        promise: fetch(t.target.dataset.productUrl)
      }, this.fetchedUrls.push(t.target.dataset.productUrl))
    }
    handleOpenCartClick(t) {
      this.cartDrawer ? (t.preventDefault(), this.cartDrawer.open()) : window.location
        .pathname === theme.routes.cart && (t.preventDefault(), this.close())
    }
    handleDocumentClick(t) {
      if (t.target.matches(".js-quick-add")) {
        if (this.cartDrawer && "false" === this.cartDrawer.ariaHidden) {
          let e = document.querySelector(".js-overlay.is-visible");
          e && (e.style.transitionDelay = "200ms"), this.cartDrawer.close(), setTimeout(() => {
            this.backBtn.hidden = !1, this.open(t.target), e && (e.style.transitionDelay = "")
          }, 200)
        } else this.open(t.target)
      }
    }
    handleVariantChange(t) {
      let e = this.productUrl;
      if (t.detail.variant) {
        let i = this.productUrl.split("?").length > 1 ? "&" : "?";
        e += `${i}variant=${t.detail.variant.id}`
      }
      this.querySelectorAll(".js-prod-link").forEach(t => {
        t.href = e
      })
    }
    async open(t) {
      if (t.setAttribute("aria-disabled", "true"), this.notification && (this.notification
          .hidden = !0), this.productUrl && this.productUrl === t.dataset.productUrl) {
        super.open(t), t.dataset.selectedColor && this.setActiveVariant(t), t.removeAttribute(
          "aria-disabled");
        return
      }
      this.productUrl = t.dataset.productUrl, this.content.innerHTML = "", this.classList.add(
          "is-loading"), this.content.classList.add("drawer__content--out"), this.footer.classList
        .add("drawer__footer--out"), super.open(t), this.fetch && this.fetch.url === t.dataset
        .productUrl || (this.fetch = {
          url: t.dataset.productUrl,
          promise: fetch(t.dataset.productUrl)
        });
      let e = await this.fetch.promise;
      if (e.ok) {
        let i = document.createElement("template");
        i.innerHTML = await e.text(), this.productEl = i.content.querySelector(".js-product"),
          this.renderProduct(t)
      }
      this.fetch = null, t.removeAttribute("aria-disabled")
    }
    close() {
      super.close(() => {
        this.backBtn.hidden = !0
      })
    }
    renderProduct(t) {
      let e = this.productEl.dataset.section;
      this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(e, "quickadd");
      let i = this.productEl.querySelector("variant-picker");
      i && (i.dataset.updateUrl = "false");
      let r = this.productEl.querySelector('[data-modal="size-chart"]');
      r && r.remove(), this.updateContent(), this.updateForm();
      let s = this.productEl.querySelector(".media-viewer__item.is-current-variant");
      s && this.updateMedia(s.dataset.mediaId), t.dataset.selectedColor && setTimeout(this
        .setActiveVariant.bind(this, t), 10)
    }
    setActiveVariant(t) {
      let e = this.querySelector(`.opt-btn[value="${t.dataset.selectedColor}"]`);
      if (e) this.querySelector(`.opt-btn[value="${t.dataset.selectedColor}"]`).click();
      else {
        let i = this.querySelector(
          `.custom-select__option[data-value="${t.dataset.selectedColor}"]`);
        if (i) {
          let r = i.closest("custom-select");
          r.selectOption(i)
        }
      }
    }
    updateMedia(t) {
      let e = this.productEl.querySelector(`[data-media-id="${t}"] img`);
      if (!e) return;
      let i = e.src ? e.src.split("&width=")[0] : e.dataset.src.split("&width=")[0],
        r = this.querySelector(".quick-add-info__media"),
        s = r.offsetWidth,
        d = e.width / e.height;
      r.innerHTML = `
        <img src="${i}&width=${s}" srcset="${i}&width=${s}, ${i}&width=${2*s} 2x" width="${2*s}" height="${2*s/d}" alt="${e.alt}">
      `
    }
    updateContent() {
      let t = this.getElementHtml(".product-info__weight");
      t && t.length > 0 && (t = `<div class="product-info__weight text-sm mt-2">${t}</div>`), this
        .content.innerHTML = `
        <div class="quick-add-info grid mb-8">
          <div class="quick-add-info__media${theme.settings.blendProductImages?" image-blend":""}"></div>
          <div class="quick-add-info__details">
            <div class="product-vendor-sku mb-2 text-sm">
              ${this.getElementHtml(".product-vendor-sku")}
            </div>
            <div class="product-title">
              <a class="h6 js-prod-link" href="${this.productUrl}">
                ${this.getElementHtml(".product-title")}
              </a>
            </div>
            ${t}
            <hr>
            <div class="product-price">
              ${this.getElementHtml(".product-price")}
            </div>
            <div class="text-theme-light text-sm mt-4">
              <a href="${this.productUrl}" class="link js-prod-link">
                ${theme.strings.viewDetails}
              </a>
            </div>
          </div>
          <div class="quick-add-info__details md:hidden"></div>
        </div>
        <div class="product-options">
          ${this.getElementHtml(".product-options")}
        </div>
        <div class="product-backorder">
          ${this.getElementHtml(".product-backorder")}
        </div>
      `, this.classList.remove("is-loading"), this.content.classList.remove("drawer__content--out")
    }
    updateForm() {
      let t = this.productEl.querySelector("product-form");
      if (this.footer.classList.remove("quick-add__footer-message"), t) this.form.innerHTML = t
        .innerHTML, this.form.init(), Shopify && Shopify.PaymentButton && Shopify.PaymentButton
        .init();
      else {
        let e = this.productEl.querySelector(".product-signup");
        e ? this.form.innerHTML = e.innerHTML : (this.footer.classList.add(
          "quick-add__footer-message"), this.form.innerHTML = `
            <div class="alert quick-add__alert bg-info-bg text-info-text">
              <div class="flex">
                <div>
                  <svg class="icon icon--price_tag" width="32" height="32" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                    <path fill="currentColor" d="M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z" fill-rule="evenodd"/>
                    <path fill="currentColor" d="M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z" fill-rule="evenodd"/>
                  </svg>
                </div>
                <div>
                  <p class="text-h6 font-bold mb-2">${theme.strings.awaitingSale}</p>
                  <a class="link js-prod-link" href="${this.productUrl}">${theme.strings.viewDetails}</a>
                </div>
              </div>
            </div>`)
      }
      this.footer.classList.remove("drawer__footer--out")
    }
    getElementHtml(t) {
      let e = this.productEl.querySelector(t);
      return e ? e.innerHTML : ""
    }
    addedToCart() {
      this.notification && (setTimeout(() => {
        this.notification.hidden = !1
      }, 300), setTimeout(() => {
        this.notification.hidden = !0
      }, this.notification.dataset.visibleFor))
    }
  }
  customElements.define("quick-add-drawer", t)
}
